import { IRequestParams, IResultContent, request } from "@fanfanlo";
import _ from "lodash";
import { appProxyModel } from "../../mc/app/AppModel";
import { IRequestOptions } from "../IRequestOptions";
import { tms } from "../tms";
import { ITablePrimeAppUser } from "../../tables/prime/app-user";
import { ITableGlobalRegisteredUser } from "../../tables/global/registered-user";
import { IJwtData } from "../user/loginByCode";

export interface IVisitAppStartParams extends IRequestParams{
    user_token?:string
    device_info_uuid?:string
    device_id:string
    browser_id:string
    client_user_uuid?:string
}

export async function tmsVisitAppStart(opts:IRequestOptions<IVisitAppStartParams>){
    const res = await request<IVisitResult>(tms.TVisit, tms.MVisitAppStart, opts.params, opts.gateway, opts.handler);
    if(!res.dataIsOk){
      // 这就是错误了，需要在具体使用数据的地方进行展示或者处理
      console.log('tmsVisitAppStart error:', res.err, res);
      return res;
    }
    if(res.data){
        const visit = createDefaultVisit()
        for(const key in res.data){
            (visit as any)[key] = (res.data as any)[key]
        }
        appProxyModel.visitInfo = visit
    }
    return res
}
export interface IVisit {
  device_info_uuid: string;
  client_user_uuid: string;
  client_ticket_uuid: string;
	im_matrix_user_id?: string  // im user id type of uuid
	im_matrix_pw?:     string  // im user pw random strings
}
export interface IVisitResult extends IResultContent{
  visit:IVisit
  app_user_info?:ITablePrimeAppUser
  global_user_info?:ITableGlobalRegisteredUser
  jwt_data?:IJwtData
}
export function createDefaultVisit(data?: Partial<IVisit>): IVisit {
  const visit: IVisit = {
    device_info_uuid: '',
    client_user_uuid: '',
    client_ticket_uuid: '',
    im_matrix_user_id: '',
    im_matrix_pw: '',
  };
  return _.merge(visit, data || {});
}
